import {$, Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {INotasInseridasResourcesHolder} from '@/interfaces/resource/INotasInseridasResourcesHolder'
import {NotasInseridasFilterCollection} from '@/model/filter/NotasInseridasFilterCollection'

export class NotasInseridasFilterSchema extends Schema
  implements INotasInseridasResourcesHolder {
  readonly name = 'NotasInseridasFilter'

  fieldsToShow(isWeekly: boolean) {
    if (isWeekly) {
      return ['mesAsResource', 'anoAsResource']
    } else {
      return ['anoAsResource']
    }
  }

  readonly fieldSet: FieldSet<NotasInseridasFilterCollection> = {
    mesAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        items: schema.model.monthOptions().all(),
        label: this.translateFrom(schema.fieldName),
      },
    }),
    anoAsResource: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        items: schema.model.yearList?.all(),
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
